import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { AlertService } from 'src/app/shared/services/alert.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'consultar-historico',
  templateUrl: './consultar-historicos.component.html',
  styleUrls: ['./consultar-historico.component.scss']
})
export class ConsultarHistoricoComponent implements OnInit {

  cargandoArchivo: boolean;
  detalleParametros;
  nombreArchivo: string;
  fileToUpload: File;
  myInputVariable: ElementRef;
  archivo: any;
  habilitarboton = false;
  documentos: any[];
  documentoSeleccionado: any;

  constructor(
    private router: Router,
    private sanitizer: DomSanitizer,
    private global: GlobalService,
    private urlService: UrlService,
    private spinner: NgxSpinnerService,
    private alertService: AlertService) {
    this.nombreArchivo = ConstantesService.SELECCIONAR_ARCHIVO;
    this.cargandoArchivo = false;
  }

  ngOnInit() {

  }

  /**
   * Método para regresar a la pantalla principalo
   * @return void
   */
  public regresarListado() {
    this.router.navigate(['/main']);
  }

  consultarDocumentos() {
    const uriService = this.urlService.getUrl(new UrlControl('ConsultarDocumentos', null, null), this.urlService.hostAPI_ACCVIS);
    this.global.getGenerico(uriService).subscribe(data => {
      this.documentos = data;
    }, error => this.cathException(error));
  }

  seleccionarDocumento(documento) {
    this.documentoSeleccionado = documento;
  }

  /**
   * Método que prepara los datos para realizar la descarga del documento seleccionado
   * @return void
   */
  descargar = () => {
    const service = 'descargarDocumento';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['url', this.urlService.encodeURI(this.documentoSeleccionado.url)]);
    queryParams.push(['nombre', this.urlService.encodeURI(this.documentoSeleccionado.nombre)]);
    const uriService = this.urlService.getUrl(new UrlControl(service, null, queryParams), this.urlService.hostAPI_ACCVIS);
    this.buscarDocumento(uriService, 0);
  }

  /**
   * Método que consume el servicio de descarga del documento seleccionado
   * @param  uriService: any {url en la que se intenta obtener el documento}
   * @param  intento: number {intento para realizar la descarga maximo permitido 2 iniciando en 0}
   * @return void
   */
  buscarDocumento(uriService, intento: number) {
    this.global.getNoMap(uriService).subscribe(data => {
      this.documentoSeleccionado = undefined;
      this.alertService.generateAlertSuccess('El archivo se ha descargado exitosamente', ' ');
      window.open(uriService, '_blank');
    }, error => {
      if (intento < 3) {
        setTimeout(() => this.buscarDocumento(uriService, ++intento), 100);
      } else {
        this.documentoSeleccionado = undefined;
        this.cathException(error);
      }
    });
  }


  /**
   * Método de control de Excepciones
   * @param error mensaje respecto al error ocurrido
   * @return void
   */
  cathException(error) {
    this.spinner.hide();
    if (error.error && error.error.message) {
      this.alertService.generateAlertError(error.error.message, 'Error');
    } else {
      this.alertService.generateAlertError('Se presentó un error, por favor intente más tarde', 'Error');
    }
  }
}
